<template>
    <div style="padding: 15px;height: 100vh">
        <div v-if="render_type == 'all'" class="app-content">
            <a-card title="การแจ้งซ่อม">
                <template v-if="!business" #extra>
                    <a-space>
                        <router-link v-if="editable" :to="`/app/repair/add`">
                            <a-button style="display: flex" type="primary" size="large">
                                <template #icon><span class="material-symbols-outlined">Add</span></template>
                                เพิ่มการแจ้งซ่อม
                            </a-button>
                        </router-link>
                        <a-button v-if="businessTypeId == 3" ref="import_file" @click="export_file()">
                            <span class="material-symbols-outlined">download</span>Export
                        </a-button>
                    </a-space>
                </template>
                <a-row v-if="business" style="display: flex; justify-content: flex-end;">
                    <a-space>
                        <router-link v-if="editable" :to="`/app/repair/add`">
                            <a-button style="display: flex" type="primary" size="large">
                                <template #icon><span class="material-symbols-outlined">Add</span></template>
                                เพิ่มการแจ้งซ่อม
                            </a-button>
                        </router-link>
                    </a-space>
                </a-row>
                <br>
                <a-row type="flex" :gutter="[16, 0]">
                    <a-col>
                        <a-dropdown v-model:visible="car_filter_visible" :trigger="['click']">
                        <template #overlay>
                            <a-menu>
                                <a-menu-item key="1">
                                    1.ทะเบียนรถ
                                    <a-select
                                    style="width: 280px"
                                    v-model:value="search_car"
                                    placeholder="ทะเบียนรถ"
                                    >
                                        <a-select-option
                                            v-for="({ id, name }, i) in plate_no_list"
                                            :key="i"
                                            :value="name"
                                            >{{ name }}
                                        </a-select-option>
                                    </a-select>
                                </a-menu-item>
                                <a-menu-item key="2">
                                    2.บริษัทรถ
                                    <a-select
                                    style="width: 280px"
                                    v-model:value="selected_company"
                                    placeholder="บริษัทรถ"
                                    >
                                        <a-select-option
                                            v-for="({ id, fullname }, i) in car_company_list"
                                            :key="i"
                                            :value="id"
                                            >{{ fullname }}
                                        </a-select-option>
                                    </a-select>
                                </a-menu-item>
                                <a-menu-item key="3">
                                    3.ประเภทการซ่อม
                                    <a-select
                                    style="width: 280px"
                                    v-model:value="selected_type_id"
                                    placeholder="ประเภทการซ่อม"
                                    >
                                        <a-select-option
                                            v-for="({ id, name }, i) in car_repair_type_list"
                                            :key="i"
                                            :value="id"
                                            >{{ name }}
                                        </a-select-option>
                                    </a-select>
                                </a-menu-item>
                                <a-menu-item key="1">
                                    4.สถานะแจ้งซ่อม
                                    <a-select
                                    style="width: 280px"
                                    v-model:value="selected_status"
                                    placeholder="สถานะแจ้งซ่อม"
                                    >
                                        <a-select-option
                                            v-for="({ id, status }, i) in repair_status_list"
                                            :key="i"
                                            :value="id"
                                            >{{ status }}
                                        </a-select-option>
                                    </a-select>
                                </a-menu-item>
                            </a-menu>
                        </template>
                        <a-button style="width: 225px">
                            <div
                            v-if="!car_filter_title"
                            style="
                                display: flex;
                                justify-content: space-between;
                                width: 100%;
                            "
                            >
                            <span style="color: grey">ข้อมูลรถ</span>
                            <span
                                class="material-symbols-outlined"
                                style="font-size: 16px; color: grey"
                                >directions_car</span
                            >
                            </div>
                            <div
                            v-else
                            style="
                                display: flex;
                                justify-content: space-between;
                                width: 100%;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            "
                            >
                            {{ car_filter_title }}
                            </div>
                        </a-button>
                        </a-dropdown>
                    </a-col>
                    <a-col>
                        <a-button type="primary" @click="clear_search()" v-if="clear">ล้าง</a-button>
                    </a-col>
                </a-row>
                <br>
                <a-row>
                    <a-table :columns="[
                        {
                            title: 'บริษัท',
                            dataIndex: 'car_company',
                            key: 'car_company',
                            sorter: true,
                            width: 300,
                            align: 'center',
                        }, 
                        {
                            title: 'ทะเบียนรถ',
                            dataIndex: 'car',
                            key: 'car',
                            sorter: true,
                            width: 175,
                            align: 'center',
                        }, 
                        {
                            title:'รายการแจ้งซ่อม',
                            dataIndex: 'story',
                            key: 'story',
                            width: 150,
                            ellipsis: true,
                            align: 'center',
                        },
                        {
                            title: 'ประเภทการซ่อม',
                            dataIndex: 'car_repair_type_id',
                            key: 'car_repair_type_id',
                            width: 200,
                            align: 'center',
                        },  
                        {
                            title: 'วันที่แจ้งซ่อม',
                            dataIndex: 'created_at',
                            key: 'created_at',
                            width: 175,
                            align: 'center',
                        }, 
                        {
                            title: 'วันที่เริ่มซ่อม',
                            dataIndex: 'time_start',
                            key: 'time_start',
                            width: 175,
                            align: 'center',
                        }, 
                        {
                            title: 'วันที่ซ่อมเสร็จ',
                            dataIndex: 'time_end',
                            key: 'time_end',
                            width: 175,
                            align: 'center',
                        }, 
                        {
                            title: 'สถานะการซ่อม',
                            dataIndex: 'car_repair_status_id',
                            key: 'car_repair_status_id',
                            width: 175,
                            align: 'center',
                        }, 
                        {
                            title: 'ตัวเลือก',
                            dataIndex: 'id',
                            key: 'id',
                            width: 135,
                            align: 'center',
                            fixed: 'right'
                        }
                    ].filter((c)=> !editable ? !c.key.includes('id') : true)" :data-source="filtered_list(repairing_list)" bordered size="small"
                        :scroll="{ x: 'calc(100px + 50%)', y: '100%' }">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'id'">
                                <a-row style="display: flex; justify-content: center">
                                    <a @click="edit_repair_status(record.id, record)"><span style="font-size: 14px"
                                            class="material-symbols-outlined">menu</span></a>
                                    <a-divider type="vertical"></a-divider>
                                    <router-link :to="`/app/repair/${record.id}`">
                                        <span style="font-size: 14px"
                                            class="material-symbols-outlined">drive_file_rename_outline</span>
                                    </router-link><a-divider type="vertical"></a-divider>
                                    <a @click="remove_car_repair(record.id, record.quotationNo)"><span
                                            style="font-size: 18px" class="material-symbols-outlined">delete</span></a>
                                </a-row>
                            </template>
                            <template v-if="column.key === 'car_repair_type_id'">
                                {{ record.car_repair_type?.name }}
                            </template>
                            <template v-else-if="column.key == 'isAir'">
                                <a-switch v-model:checked="record.isAir" />
                            </template>
                            <template v-else-if="column.key === 'created_at'">
                                {{ record.created_at ? render_date(record.created_at) : '-' }}
                            </template>
                            <template v-else-if="column.key === 'time_start'">
                                {{ record.time_start ? render_date(record.time_start) : '-' }}
                            </template>
                            <template v-else-if="column.key === 'time_end'">
                                {{ record.time_end ? render_date(record.time_end) : '-' }}
                            </template>
                            <template v-else-if="column.key === 'car_repair_status_id'">
                                <div :style="repairStatusStyle(record?.car_repair_status_id)">
                                    {{ repair_status_list.find((statusList)=>statusList.id == record.car_repair_status_id)?.status??'-' }}
                                </div>
                            </template>
                        </template>

                    </a-table>
                </a-row>
            </a-card>
        </div>

        <div v-else-if="render_type == 'add'" class="app-content">
            <a-card title="รายการแจ้งซ่อม">
                <template #extra>
                    <a-button style="display: flex" @click="$router.go(-1)" size="large">
                        <template #icon>
                            <span class="material-symbols-outlined">arrow_back_ios</span>
                        </template>
                        ย้อนกลับ
                    </a-button>
                </template>

                <a-divider orientation="left">ข้อมูลที่ต้องการซ่อม</a-divider>

                <a-row style="margin-top: 35px;" type="flex">
                    <a-col :span="8">
                        <a-form-item label="ลูกค้า/บริษัท" name="car_company"
                            :colon="false"
                            :rules="[{ required: true, message: 'Please input field!' }]">
                        </a-form-item>
                        <a-select style="width: 95%" v-model:value="car_repair.car_company_id"
                            placeholder="เลือกบริษัท" @change="repairebyCarCompany()">
                            <a-select-option v-for="{ id, fullname }, i in car_company_list" :key="i" :value="id">{{
                                    fullname
                            }}</a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item :label="businessTypeId == 4 ? 'รถยนต์ที่ต้องการแจ้งซ่อม' : 'รถที่ต้องการซ่อม'" name="car_id"
                            :colon="false"
                            :rules="[{ required: true, message: 'Please input field!' }]">
                        </a-form-item>
                        <a-select style="width: 95%" v-model:value="car_repair.car_id" placeholder="เลือกรถ"
                            @change="select_car(car_repair.car_id)">
                            <a-select-option v-for="{ id, plate_no }, i in repaireCarCompany" :key="i" :value="id">{{
                                    plate_no
                            }}</a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item :label="businessTypeId == 4 ? 'ประเภทแจ้งซ่อม' : 'ประเภทที่ต้องการซ่อม'" name="car_repair_type_id"
                            :colon="false"
                            :rules="[{ required: true, message: 'Please input field!' }]">
                        </a-form-item>
                        <a-select style="width: 95%" v-model:value="car_repair.car_repair_type_id" placeholder="เลือกประเภท" >
                            <a-select-option v-for="{ id, name }, i in car_repair_type_list" :key="i" :value="id">{{
                                    name
                            }}</a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row style="margin-top: 35px;" type="flex">
                    <a-col :span="8">
                        <a-form-item label="วันที่แจ้งซ่อม" name="created_at"
                            :colon="false"
                            :rules="[{ required: true, message: 'Please input field!' }]">
                        </a-form-item>
                        <a-date-picker 
                            placeholder="ระบุวันที่แจ้งซ่อม" 
                            style="width: 95%"
                            v-model:value="car_repair.created_at" />
                    </a-col>
                    <a-col :span="8">
                        <a-form-item :label="businessTypeId == 4 ? 'วันที่เริ่มซ่อม' : 'วันที่เริ่มต้น'" name="time_start" :colon="false">
                        </a-form-item>
                        <a-date-picker 
                            placeholder="ระบุวันที่เริ่มต้น" 
                            style="width: 95%"
                            v-model:value="car_repair.time_start" />
                    </a-col>
                    <a-col :span="8">
                        <a-form-item :label="businessTypeId == 4 ? 'วันที่ซ่อมเสร็จสิ้น' : 'วันที่เสร็จสิ้นการซ่อม'" name="time_end" :colon="false">
                        </a-form-item>
                        <a-date-picker 
                            placeholder="ระบุวันที่เสร็จสิ้นการซ่อม" 
                            style="width: 95%"
                            v-model:value="car_repair.time_end" />
                    </a-col>
                </a-row>

                <a-row style="margin-top: 35px;" type="flex">
                    <a-col :span="6">
                        <a-form-item label="ทะเบียนรถ" name="plate_no" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="ระบุทะเบียนรถ" style="width: 95%"
                            v-model:value="selected_car.plate_no" />
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="ประเภทรถ" name="time_start" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="ระบุประเภทรถ" style="width: 95%"
                            v-model:value="selected_car.car_type_name" />
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="ชื่อพนักงานคนขับ" name="time_end" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="ไม่มีคนขับ" style="width: 95%"
                            v-model:value="selected_car.driver_name" />
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="เบอร์โทรคนขับ" name="time_end" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="ไม่มีคนขับ" style="width: 95%"
                            v-model:value="selected_car.driver_tel" />
                    </a-col>
                </a-row>

                <a-row style="margin-top: 35px;" type="flex">
                    <a-col :span="6">
                        <a-form-item label="เลขไมล์ปัจจุบัน" name="plate_no" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="เลขไมล์รวม (กิโลเมตร)" style="width: 95%"
                            v-model:value="distance" />
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="วันที่บันทึกเลขไมล์" name="time_start" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="วันที่บันทึก" style="width: 95%"
                            v-model:value="updatedAtOdometer" />
                    </a-col>
                </a-row>

                <a-divider style="margin-top: 35px;" orientation="left">รายการแจ้งซ่อม</a-divider>
                <a-table :columns="[
                    {
                        title: 'รายการแจ้งซ่อม',
                        dataIndex: 'story',
                        key: 'story',
                    }, 
                    {
                        title: 'ประเภทรายการ',
                        dataIndex: 'repair_story_type_id',
                        key: 'repair_story_type_id',
                    }, 
                    {
                        title: 'ประเภทรายการอื่นๆ',
                        dataIndex: 'repair_story_type_other',
                        key: 'repair_story_type_other',
                    }, 
                    {
                        title: 'รายละเอียด',
                        dataIndex: 'detail',
                        key: 'detail',
                    }, 
                    {
                        title: 'สถานที่ซ่อม',
                        dataIndex: 'location',
                        key: 'location',
                    }, 
                    {
                        title: 'ค่าใช้จ่าย',
                        dataIndex: 'repair_expense',
                        key: 'repair_expense',
                    }, 
                    {
                        title: 'ตัวเลือก',
                        dataIndex: 'id',
                        key: 'id',
                        width: 100,
                        align: 'center',
                        fixed: 'right'
                    }
                ]" :data-source="car_repair.repair_story" bordered size="small">
                    <template #bodyCell="{ column, record, index}">
                        <template v-if="column.key === 'id'">
                            <a-row>
                                <a @click="edit_car_repair_story(index, record)"><span style="font-size: 14px"
                                        class="material-symbols-outlined">drive_file_rename_outline</span></a>
                                <a-divider type="vertical"></a-divider>
                                <a @click="remove_car_repair_story(index, record)"><span
                                        style="font-size: 14px" class="material-symbols-outlined">delete</span></a>
                            </a-row>
                        </template>
                        <template v-else-if="column.key === 'repair_story_type_id'">
                            {{ record.repair_story_type_id == 12 ? '' : getRepairStoryTypeName(record.repair_story_type_id) }}
                        </template>
                        <template v-else-if="column.key === 'repair_story_type_other'">
                            {{ record.repair_story_type_id != 12 ? '' : record.repair_story_type_other }}
                        </template>
                    </template>

                </a-table>
                <a-row justify="end">
                    <a-col>
                        <a-button @click="create_car_repair_story()" type="primary" html-type="submit" size="large"
                            style="margin: 4px;text-align: right">
                            <span class="material-symbols-outlined" style="font-size: 16px;margin-right: 4px">Add</span>
                            เพิ่มรายการแจ้งซ่อม
                        </a-button>
                    </a-col>
                </a-row>

                <a-drawer v-model:visible="show_drawer" class="custom-class" style="color: red" title="รายการแจ้งซ่อม" destroyOnClose
                    placement="right">
                        <!-- <a-form :model="repair_story" :layout="'vertical'"> -->
                    <a-form :model="repair_story" layout="vertical">
                        <a-row type="flex">
                            <a-col :span="24">
                                <a-form-item :has-feedback="!!repair_story.story" :rules="[{ required: true, message: 'กรุณาระบุรายการแจ้งซ่อม' }]" :label="'รายการแจ้งซ่อม'" name="story" :colon="false" >
                                    <a-input :placeholder="'ระบุรายการแจ้งซ่อม'" style="width: 100%" v-model:value="repair_story.story" />
                                </a-form-item>
                            </a-col>
                            <a-col style="margin-top: 30px;" :span="24">
                                <a-form-item :rules="[{ required: true, message: 'กรุณาเลือกประเภท' }]" label="ประเภทรายการ" :colon="false" name="repair_story_type_id">
                                    <a-select placeholder="เลือกประเภท" style="width: 100%" v-model:value="repair_story.repair_story_type_id">
                                        <a-select-option v-for="item in repairStoryTypesList" :key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item> 
                            </a-col>
                            <a-form-item :rules="[{ required: true, message: 'กรุณาระบุประเภทรายการซ่อมอื่นๆ' }]" v-if="repair_story.repair_story_type_id == 12" style="margin-top: 10px;" label="ประเภทรายการซ่อมอื่นๆ">
                                <a-input 
                                    placeholder="ระบุประเภทรายการซ่อม" 
                                    style="width: 100%;" 
                                    v-model:value="repair_story.repair_story_type_other">
                                </a-input>
                            </a-form-item>
                            <a-col style="margin-top: 30px;" :span="24">
                                <a-form-item :rules="[{ required: false, message: 'กรุณาระบุรายละเอียด' }]" label="รายละเอียด" name="detail" :colon="false">
                                    <a-textarea placeholder="ระบุรายละเอียด" style="width: 100%"
                                    v-model:value="repair_story.detail" />                                
                                </a-form-item>
                            </a-col>
                            <a-col style="margin-top: 30px;" :span="24">
                                <a-form-item :has-feedback="!!repair_story.location" :rules="[{ required: true, message: 'กรุณาระบุสถานที่ซ่อม' }]" label="สถานที่ซ่อม" name="location" :colon="false">
                                    <a-input placeholder="ระบุสถานที่ซ่อม" style="width: 100%"
                                    v-model:value="repair_story.location" />                                
                                </a-form-item>
                            </a-col>
                            <a-col style="margin-top: 30px;" :span="24">
                                <a-form-item :rules="[ 
                                    { required: true, message: 'กรุณาระบุจำนวนเงิน', trigger: 'change' },
                                    { validator: validate_number, trigger: 'change' }
                                ]" 
                                    :has-feedback="!!repair_story.repair_expense"
                                    label="ค่าใช้จ่าย" :colon="false" name="repair_expense">
                                    <a-input placeholder="ระบุจำนวนเงิน (บาท)" style="width: 100%"
                                    v-model:value="repair_story.repair_expense" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col style="margin-top: 30px;" :span="24">
                                <a-form-item label="รูปภาพส่วนที่เสียหาย" name="time_end" :colon="false">
                                    <a-upload v-model:file-list="fileList" list-type="picture-card"
                                        class="avatar-uploader"
                                        :maxCount="5"
                                        accept="image/png, image/jpeg, image/jpg,"
                                        :before-upload="handleBeforeUpload"
                                        method="GET"
                                        @preview="handlePreview"
                                        @remove="remove_repair_story_photo"
                                        >
                                        <div v-if="fileList?.length < 5" style="height: 104px; width: 104px; padding: 2rem">
                                            <span style="font-size: 20px" class="material-symbols-outlined">add</span>
                                            <div style="margin-top: 8px">Upload</div>
                                        </div>
                                    </a-upload>                                
                                </a-form-item>
                            </a-col>
                        </a-row>
                        
                        <br><br>
                        <a-row justify="end">
                            <a-col>
                                <a-button @click="submit_repair_story()" type="primary" html-type="submit" size="large"
                                    style="margin: 4px;text-align: right">
                                    <span class="material-symbols-outlined"
                                        style="font-size: 16px;margin-right: 4px">Add</span>
                                    เพิ่มข้อมูล
                                </a-button>
                            </a-col>
                        </a-row>
                    </a-form>
                <!-- </a-form> -->
                </a-drawer>

                <a-divider orientation="left">เอกสารที่เกี่ยวข้อง</a-divider>
                <a-upload v-model:file-list="car_repair.photos" list-type="picture-card"
                        class="avatar-uploader"
                        accept="image/png, image/jpeg, image/jpg, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        @preview="handlePreview"
                        :before-upload="handleBeforeUploadCarRepair"
                        method="GET">
                        <div v-if="car_repair.photos.length < 5" style="height: 104px; width: 104px; padding: 2rem">
                            <span style="font-size: 20px" class="material-symbols-outlined">add</span>
                            <div style="margin-top: 8px">Upload</div>
                        </div>
                </a-upload>

                <a-divider orientation="left">หมายเหตุ (ผู้แจ้งซ่อม)</a-divider>
                <a-textarea placeholder="ระบุหมายเหตุ" v-model:value="car_repair.remark" />

                <a-row justify="end">
                    <a-col>
                        <a-button @click="submit_create_car_repair()" type="primary" html-type="submit" size="large"
                            style="margin: 4px;text-align: right" :disabled="!(car_repair.repair_story?.length > 0)">
                            <span class="material-symbols-outlined" style="font-size: 16px;margin-right: 4px">Add</span>
                            บันทึกข้อมูล
                        </a-button>
                    </a-col>
                </a-row>
            </a-card>
        </div>

        <div v-else class="app-content">
            <a-card title="รายการแจ้งซ่อม">
                <template #extra>
                    <a-button style="display: flex" @click="$router.go(-1)" size="large">
                        <template #icon>
                            <span class="material-symbols-outlined">arrow_back_ios</span>
                        </template>
                        ย้อนกลับ
                    </a-button>
                </template>

                <a-divider orientation="left">ข้อมูลที่ต้องการซ่อม</a-divider>

                <a-row style="margin-top: 35px;" type="flex">
                    <a-col :span="8">
                        <a-form-item label="ลูกค้า/บริษัท" name="car_company"
                            :colon="false"
                            :rules="[{ required: true, message: 'Please input field!' }]">
                        </a-form-item>
                        <a-select style="width: 95%" v-model:value="car_repair.car_company_id" :disabled="car_repair.car_repair_status_id == 2 || car_repair.car_repair_status_id == 3 || car_repair.car_repair_status_id == 4"
                            placeholder="เลือกบริษัท">
                            <a-select-option v-for="{ id, fullname }, i in car_company_list" :key="i" :value="id">{{
                                    fullname
                            }}</a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="รถที่ต้องการซ่อม" name="car_id"
                            :colon="false"
                            :rules="[{ required: true, message: 'Please input field!' }]">
                        </a-form-item>
                        <a-select style="width: 95%" v-model:value="car_repair.car_id" placeholder="เลือกรถ" :disabled="car_repair.car_repair_status_id == 2 || car_repair.car_repair_status_id == 3 || car_repair.car_repair_status_id == 4"
                            @change="select_car(car_repair.car_id)">
                            <a-select-option v-for="{ id, plate_no }, i in car_list" :key="i" :value="id">{{
                                    plate_no
                            }}</a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="ประเภทที่ต้องการซ่อม" name="car_repair_type_id"
                            :colon="false"
                            :rules="[{ required: true, message: 'Please input field!' }]">
                        </a-form-item>
                        <a-select style="width: 95%" v-model:value="car_repair.car_repair_type_id" placeholder="เลือกประเภท" :disabled="car_repair.car_repair_status_id == 2 || car_repair.car_repair_status_id == 3 || car_repair.car_repair_status_id == 4">
                            <a-select-option v-for="{ id, name }, i in car_repair_type_list" :key="i" :value="id">{{
                                    name
                            }}</a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row style="margin-top: 35px;" type="flex">
                    <a-col :span="8">
                        <a-form-item label="วันที่แจ้งซ่อม" name="created_at"
                            :colon="false"
                            :rules="[{ required: true, message: 'Please input field!' }]">
                        </a-form-item>
                        <a-date-picker 
                            placeholder="ระบุวันที่แจ้งซ่อม" 
                            style="width: 95%"
                            :disabled="car_repair.car_repair_status_id == 2 || car_repair.car_repair_status_id == 3 || car_repair.car_repair_status_id == 4"
                            v-model:value="car_repair.created_at" />
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="วันที่เริ่มต้น" name="time_start" :colon="false">
                        </a-form-item>
                        <a-date-picker 
                            placeholder="ระบุวันที่เริ่มต้น" 
                            style="width: 95%"
                            :disabled="car_repair.car_repair_status_id == 2 || car_repair.car_repair_status_id == 3 || car_repair.car_repair_status_id == 4"
                            v-model:value="formattedTimeStart" />
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="วันที่เสร็จสิ้นการซ่อม" name="time_end" :colon="false">
                        </a-form-item>
                        <a-date-picker 
                            placeholder="ระบุวันที่เสร็จสิ้นการซ่อม" 
                            style="width: 95%"
                            :disabled="car_repair.car_repair_status_id == 2 || car_repair.car_repair_status_id == 3 || car_repair.car_repair_status_id == 4"
                            v-model:value="formattedTimeEnd" />
                    </a-col>
                </a-row>

                <a-row style="margin-top: 35px;" type="flex">
                    <a-col :span="6">
                        <a-form-item label="ทะเบียนรถ" name="plate_no" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="ระบุทะเบียนรถ" style="width: 95%"
                            v-model:value="selected_car.plate_no" />
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="ประเภทรถ" name="time_start" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="ระบุประเภทรถ" style="width: 95%"
                            v-model:value="selected_car.car_type_name" />
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="ชื่อพนักงานคนขับ" name="time_end" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="ไม่มีคนขับ" style="width: 95%"
                            v-model:value="selected_car.driver_name" />
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="เบอร์โทรคนขับ" name="time_end" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="ไม่มีคนขับ" style="width: 95%"
                            v-model:value="selected_car.driver_tel" />
                    </a-col>
                </a-row>

                <a-row style="margin-top: 35px;" type="flex">
                    <a-col :span="6">
                        <a-form-item label="เลขไมล์ปัจจุบัน" name="plate_no" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="เลขไมล์รวม (กิโลเมตร)" style="width: 95%"
                            v-model:value="distance" />
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="วันที่บันทึกเลขไมล์" name="time_start" :colon="false">
                        </a-form-item>
                        <a-input disabled placeholder="วันที่บันทึก" style="width: 95%"
                            v-model:value="updatedAtOdometer" />
                    </a-col>
                </a-row>

                <a-divider style="margin-top: 35px;" orientation="left">รายการแจ้งซ่อม</a-divider>
                <a-table :columns="[
                    {
                        title: 'รายการแจ้งซ่อม',
                        dataIndex: 'story',
                        key: 'story',
                    }, 
                    {
                        title: 'ประเภทรายการ',
                        dataIndex: 'repair_story_type_id',
                        key: 'repair_story_type_id',
                    }, 
                    {
                        title: 'ประเภทรายการอื่นๆ',
                        dataIndex: 'repair_story_type_other',
                        key: 'repair_story_type_other',
                    }, 
                    {
                        title: 'รายละเอียด',
                        dataIndex: 'detail',
                        key: 'detail',
                    }, 
                    {
                        title: 'สถานที่ซ่อม',
                        dataIndex: 'location',
                        key: 'location',
                    }, 
                    {
                        title: 'ค่าใช้จ่าย',
                        dataIndex: 'repair_expense',
                        key: 'repair_expense',
                    }, 
                    ...(car_repair.car_repair_status_id == 1 ? [{
                        title: 'ตัวเลือก',
                        dataIndex: 'id',
                        key: 'id',
                        width: 100,
                        align: 'center',
                        fixed: 'right'
                    }] : [])
                ]" :data-source="car_repair.repair_story" bordered size="small">
                    <template #bodyCell="{ column, record, index }">
                        <template v-if="column.key === 'id'">
                            <a-row>
                                <a @click="edit_car_repair_story(index, record)"><span style="font-size: 14px"
                                        class="material-symbols-outlined">drive_file_rename_outline</span></a>
                                <a-divider type="vertical"></a-divider>
                                <a @click="remove_car_repair_story(index, record)"><span
                                        style="font-size: 14px" class="material-symbols-outlined">delete</span></a>
                            </a-row>
                        </template>
                        <template v-else-if="column.key === 'repair_story_type_id'">
                            {{ record.repair_story_type_id == 12 ? '' : getRepairStoryTypeName(record.repair_story_type_id) }}
                        </template>
                        <template v-else-if="column.key === 'repair_story_type_other'">
                            {{ record.repair_story_type_id != 12 ? '' : record.repair_story_type_other }}
                        </template>
                    </template>
                </a-table>
                <a-row justify="end">
                    <a-col>
                        <a-button v-if="car_repair.car_repair_status_id == 1" @click="create_car_repair_story()" type="primary" html-type="submit" size="large"
                            style="margin: 4px;text-align: right">
                            <span class="material-symbols-outlined" style="font-size: 16px;margin-right: 4px">Add</span>
                            เพิ่มรายการแจ้งซ่อม
                        </a-button>
                    </a-col>
                </a-row>

                <a-drawer v-model:visible="show_drawer" class="custom-class" style="color: red" title="รายการแจ้งซ่อม"
                    placement="right">
                    <!-- <a-form :model="repair_story" :layout="'vertical'"> -->
                    <a-row type="flex">
                        <a-col :span="24">
                            <a-form-item :rules="[{ required: true, message: 'กรุณาระบุรายการแจ้งซ่อม' }]" :label="'รายการแจ้งซ่อม'" name="time_start" :colon="false">
                            </a-form-item>
                            <a-input :placeholder="'ระบุรายการแจ้งซ่อม'" style="width: 95%" v-model:value="repair_story.story" />
                        </a-col>
                        <a-col style="margin-top: 30px;" :span="24">
                            <a-form-item :rules="[{ required: true, message: 'กรุณาเลือกประเภท' }]" label="ประเภทรายการ" :colon="false">
                            </a-form-item>
                                <a-select placeholder="เลือกประเภท" style="width: 95%" v-model:value="repair_story.repair_story_type_id">
                                <a-select-option v-for="item in repairStoryTypesList" :key="item.id" :value="item.id">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </a-col>
                        <a-form-item :rules="[{ required: true, message: 'กรุณาระบุประเภทรายการซ่อมอื่นๆ' }]" v-if="repair_story.repair_story_type_id == 12" style="margin-top: 10px;" label="ประเภทรายการซ่อมอื่นๆ">
                            <a-input 
                                placeholder="ระบุประเภทรายการซ่อม" 
                                style="width: 95%;" 
                                v-model:value="repair_story.repair_story_type_other">
                            </a-input>
                        </a-form-item>
                        <a-col style="margin-top: 30px;" :span="24">
                            <a-form-item :rules="[{ required: false, message: 'กรุณาระบุรายละเอียด' }]" label="รายละเอียด" name="time_end" :colon="false">
                            </a-form-item>
                            <a-textarea placeholder="ระบุรายละเอียด" style="width: 95%"
                                v-model:value="repair_story.detail" />
                        </a-col>
                        <a-col style="margin-top: 30px;" :span="24">
                            <a-form-item :rules="[{ required: true, message: 'กรุณาระบุสถานที่ซ่อม' }]" label="สถานที่ซ่อม" name="location" :colon="false">
                        </a-form-item>
                        <a-input placeholder="ระบุสถานที่ซ่อม" style="width: 95%" v-model:value="repair_story.location" />
                        </a-col>
                        <a-col style="margin-top: 30px;" :span="24">
                            <a-form-item :rules="[{ required: true, message: 'กรุณาระบุจำนวนเงิน' }]" label="ค่าใช้จ่าย" :colon="false">
                            </a-form-item>
                                <a-input placeholder="ระบุจำนวนเงิน (บาท)" style="width: 95%"
                                v-model:value="repair_story.repair_expense" />
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col style="margin-top: 30px;" :span="24">
                            <a-form-item label="รูปภาพส่วนที่เสียหาย" name="time_end" :colon="false">
                            </a-form-item>
                            <a-upload v-model:file-list="fileList" list-type="picture-card"
                                class="avatar-uploader"
                                :maxCount="5"
                                accept="image/png, image/jpeg, image/jpg"
                                :before-upload="handleBeforeUpload"
                                method="GET"
                                @remove="remove_repair_story_photo"
                                >
                                <div v-if="fileList?.length < 5" style="height: 104px; width: 104px; padding: 2rem">
                                    <span style="font-size: 20px" class="material-symbols-outlined">add</span>
                                    <div style="margin-top: 8px">Upload</div>
                                </div>
                            </a-upload>
                        </a-col>
                    </a-row>
                    <br><br>
                    <a-row justify="end">
                        <a-col>
                            <a-button @click="submit_repair_story()" type="primary" html-type="submit" size="large"
                                style="margin: 4px;text-align: right">
                                <span class="material-symbols-outlined"
                                    style="font-size: 16px;margin-right: 4px">Add</span>
                                เพิ่มข้อมูล
                            </a-button>
                        </a-col>
                    </a-row>
                <!-- </a-form> -->
                </a-drawer>

                <a-divider orientation="left">เอกสารที่เกี่ยวข้อง</a-divider>
                
                <div v-if="car_repair.car_repair_status_id != 1 && car_repair.photos.length < 1" class="image-container">
                    <a-upload v-model:file-list="car_repair.photos" list-type="picture-card"
                        :disabled="car_repair.car_repair_status_id == 2 || car_repair.car_repair_status_id == 3 || car_repair.car_repair_status_id == 4"
                        class="avatar-uploader"
                        :maxCount="5"
                        accept="image/png, image/jpeg, image/jpg, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        :before-upload="handleBeforeUploadCarRepair"
                        method="GET">
                        <div v-if="car_repair.photos?.length < 5" style="height: 104px; width: 104px; padding: 2rem">
                            <span style="font-size: 20px" class="material-symbols-outlined">add</span>
                            <div style="margin-top: 8px">Upload</div>
                        </div>
                    </a-upload>
                </div>

                <div v-if="car_repair.car_repair_status_id != 1 && car_repair.photo_1" class="image-container" style="margin-right: 10px;">
                    <img :src="car_repair.photo_1" class="uploaded-image-table" alt="uploaded image" />
                    <div class="icon-container">
                        <span class="material-symbols-outlined preview-icon" @click="showPreview($event, car_repair.photo_1)">
                            visibility
                        </span>
                        <span class="material-symbols-outlined download-icon"
                            @click="getBase64Image($event, car_repair.photo_1)">
                            download
                        </span>
                    </div>
                </div>
                <div v-if="car_repair.car_repair_status_id != 1 && car_repair.photo_2" class="image-container" style="margin-right: 10px;">
                    <img v-if="car_repair.photo_2" :src="car_repair.photo_2" class="uploaded-image-table" alt="uploaded image" />
                    <div class="icon-container">
                        <span class="material-symbols-outlined preview-icon" @click="showPreview($event, car_repair.photo_2)">
                            visibility
                        </span>
                        <span class="material-symbols-outlined download-icon"
                            @click="getBase64Image($event, car_repair.photo_2)">
                            download
                        </span>
                    </div>
                </div>
                <div v-if="car_repair.car_repair_status_id != 1 && car_repair.photo_3" class="image-container" style="margin-right: 10px;">
                    <img v-if="car_repair.photo_3" :src="car_repair.photo_3" class="uploaded-image-table" alt="uploaded image" />
                    <div class="icon-container">
                        <span class="material-symbols-outlined preview-icon" @click="showPreview($event, car_repair.photo_3)">
                            visibility
                        </span>
                        <span class="material-symbols-outlined download-icon"
                            @click="getBase64Image($event, car_repair.photo_3)">
                            download
                        </span>
                    </div>
                </div>
                <div v-if="car_repair.car_repair_status_id != 1 && car_repair.photo_4" class="image-container" style="margin-right: 10px;">
                    <img v-if="car_repair.photo_4" :src="car_repair.photo_4" class="uploaded-image-table" alt="uploaded image" />
                    <div class="icon-container">
                        <span class="material-symbols-outlined preview-icon" @click="showPreview($event, car_repair.photo_4)">
                            visibility
                        </span>
                        <span class="material-symbols-outlined download-icon"
                            @click="getBase64Image($event, car_repair.photo_4)">
                            download
                        </span>
                    </div>
                </div>
                <div v-if="car_repair.car_repair_status_id != 1 && car_repair.photo_5" class="image-container">
                    <img v-if="car_repair.photo_5" :src="car_repair.photo_5" class="uploaded-image-table" alt="uploaded image" />
                    <div class="icon-container">
                        <span class="material-symbols-outlined preview-icon" @click="showPreview($event, car_repair.photo_5)">
                            visibility
                        </span>
                        <span class="material-symbols-outlined download-icon"
                            @click="getBase64Image($event, car_repair.photo_5)">
                            download
                        </span>
                    </div>
                </div>
                
                <a-upload v-if="car_repair.car_repair_status_id == 1" v-model:file-list="car_repair.photos" list-type="picture-card"
                        :disabled="car_repair.car_repair_status_id == 2 || car_repair.car_repair_status_id == 3 || car_repair.car_repair_status_id == 4"
                        class="avatar-uploader"
                        :maxCount="5"
                        @preview="handlePreview"
                        accept="image/png, image/jpeg, image/jpg, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        :before-upload="handleBeforeUploadCarRepair"
                        method="GET">
                        <div v-if="car_repair.photos?.length < 5" style="height: 104px; width: 104px; padding: 2rem">
                            <span style="font-size: 20px" class="material-symbols-outlined">add</span>
                            <div style="margin-top: 8px">Upload</div>
                        </div>
                </a-upload>

                <a-divider orientation="left">หมายเหตุ (ผู้แจ้งซ่อม)</a-divider>
                <a-textarea :disabled="car_repair.car_repair_status_id == 2 || car_repair.car_repair_status_id == 3 || car_repair.car_repair_status_id == 4" placeholder="ระบุหมายเหตุ" v-model:value="car_repair.remark" />

                <a-row justify="end">
                    <a-col>
                        <a-button @click="submit_update_car_repair()" type="primary" html-type="submit" size="large"
                            style="margin: 4px;text-align: right">
                            <span class="material-symbols-outlined" style="font-size: 16px;margin-right: 4px">Add</span>
                            บันทึกข้อมูล
                        </a-button>
                    </a-col>
                </a-row>
            </a-card>
        </div>

        <a-modal v-model:visible="show_modal" title="เลือกสถานะ" ok-text="บันทึก" cancel-text="ยกเลิก" @ok="save_status">
            <a-row type="flex" style="flex-direction: column">
                <a-form-item label="สถานะ" />
                <a-col flex="1 0">
                    <a-select style="width: 100%" v-model:value="selected_repair_status" placeholder="เลือกสถานะ"
                        :dropdownMatchSelectWidth="false">
                        <a-select-option v-for="{ id, status } in repair_status_list" :key="id" :value="id">{{
                                status
                        }}
                        </a-select-option>
                    </a-select>
                </a-col>
            </a-row>
        </a-modal>
        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false"
            class="custom-modal" style="background-color: none !important">
            <img :src="previewImage" alt="Preview" style="width: 100%;" />
        </a-modal>
    </div>
</template>

<script>
import SystemService from '../../api/SystemService'
import CarCompanyService from '../../api/CarCompanyService'
import Swal from 'sweetalert2'
import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra'
dayjs.extend(buddhistEra)
import Utility from '../../utility'
import CompanyService from '../../api/CompanyService'
import UserService from '../../api/UserService';
import XLSX from "xlsx-js-style";
import { validateNumber } from '../../components/helpers'

export default {
    name: 'repair',
    computed: {
        formattedTimeEnd: {
            get() {
                return this.car_repair.time_end === null || isNaN(this.car_repair.time_end) ? '' : this.car_repair.time_end;
            },
            set(value) {
                this.car_repair.time_end = value;
            }
        },
        formattedTimeStart: {
            get() {
                return this.car_repair.time_start === null || isNaN(this.car_repair.time_start) ? '' : this.car_repair.time_start;
            },
            set(value) {
                this.car_repair.time_start = value;
            }
        },
        updatedAtOdometer() {
            if (this.selected_car && this.selected_car.odos) {
                const odo = this.selected_car.odos.find(odo => odo.is_start === 1);
                return odo ? dayjs(odo.updated_at).format('YYYY-MM-DD') : null;
            }
            return null;
        },
        distance() {
            if (this.selected_car && this.selected_car.odos) {
                const odo = this.selected_car?.odos?.find(odo => odo.booking_status_id == 19) 
                 ? this.selected_car?.odos?.slice()?.reverse()?.find(odo => odo.booking_status_id == 19)
                 :this.selected_car?.odos?.slice()?.reverse()?.find(odo => odo.is_start === 0);
                return odo ? odo.distance : null;
            }
            return null;
        },
        render_type() {
            this.clear_selected_car()
            if(this.$route.params.type != 'add' && this.$route.params.type != 'all'){
                this.init_edit_repair()
            }
            return this.$route.params.type
        },
        car_filter_title() {
            this.car_filter_list = [];
            if (this.search_car) {
                this.car_filter_list.push({
                    key: "search_car",
                    value: this.search_car,
                    label: `ทะเบียนรถ: ${
                    this.plate_no_list.find(
                        (searchCar) => searchCar.name == this.search_car
                    )?.name
                    }`,
                });
            }
            if (this.selected_company) {
                this.car_filter_list.push({
                    key: "selected_company",
                    value: this.selected_company,
                    label: `บริษัทรถ: ${
                    this.car_company_list.find(
                        (searchCar) => searchCar.id == this.selected_company
                    )?.fullname
                    }`,
                });
            }
            if (this.selected_type_id) {
                this.car_filter_list.push({
                    key: "selected_type_id",
                    value: this.selected_type_id,
                    label: `ประเภทการซ่อม: ${
                    this.car_repair_type_list.find(
                        (searchCar) => searchCar.id == this.selected_type_id
                    )?.name
                    }`,
                });
            }
            if (this.selected_status) {
                this.car_filter_list.push({
                    key: "selected_status",
                    value: this.selected_status,
                    label: `สถานะแจ้งซ่อม: ${
                    this.repair_status_list.find(
                        (searchCar) => searchCar.id == this.selected_status
                    )?.status
                    }`,
                });
            }
    
            return this.car_filter_list.length
            ? this.car_filter_list.map(({ label }) => label).join(", ")
            : null;
        },
    },
    data() {
        return {
            repairStoryTypesList: [],
            editable: Utility.get_permission_editable_with_key('manage_repair'),
            selected_company: null,
            businessType: null,
            plate_no_list:[],
            business: false,
            selected_status: null,
            selected_type_id: null,
            search_car: null,
            repairing_list: [],
            car_company_list: [],
            car_filter_list:[],
            car_list: [],
            repair_status_list: [],
            car_repair_type_list: [],
            select_company: true,
            select_status: true,
            select_type_id: true,
            clear: true,
            car_filter_visible: false,

            /* Switch */
            show_modal: false,
            show_drawer: false,
            car_repair_photos: [],
            repair_story_photos: [],

            /* Update */
            selected_repair_id: null,
            selected_repair_status: null,

            /* Create */
            fileList: [],
            car_repair: {
                photos: [],
                repair_story: [],
            },
            select_car_company: null,
            selected_car: {
                plate_no: null,
                car_type_name: null,
                car_type_id: null,
                driver_name: null,
                driver_tel: null
            },
            repair_story: {},
            is_update_modal: false,
            update_story_index: null,
            businessTypeId: 0,
            previewImage: "",
            previewVisible: false,
            previewTitle: "",
            repaireCarCompany: [],
            isLoading: false,
        }
    },
    methods: {
        validate_number: validateNumber,
        async export_file() {
            this.$message.loading({ content: "กำลังโหลด...", key: "loading" });
            const data = this.repairing_list.map((item) => {
                const baseData = {
                    car_company: item.car_company,
                    plate_no: item.car,
                    story: item.story,
                    repair_type: item.car_repair_type.name,
                    repair_date: item.created_at? dayjs(item.created_at).format('DD/MM/YYYY HH:mm'):'-',
                    repair_start: item.time_start? dayjs(item.time_start).format('DD/MM/YYYY HH:mm'):'-',
                    repair_end: item.time_end? dayjs(item.time_end).format('DD/MM/YYYY HH:mm'):'-',
                    repair_status_id: this.repair_status_list.find((statusList)=>statusList.id == item.car_repair_status_id)?.status,
                };

                return baseData;
            });

            var headersColumn;
            headersColumn = [
                { header: "บริษัท", key: "car_company" },
                { header: "ทะเบียนรถ", key: "plate_no" },
                { header: "รายการแจ้งซ่อม", key: "story" },
                { header: "ประเภทการซ่อม", key: "repair_type" },
                { header: "วันที่แจ้งซ่อม", key: "repair_date" },
                { header: "วันที่เริ่มซ่อม", key: "repair_start" },
                { header: "วันที่ซ่อมเสร็จ", key: "repair_end" },
                { header: "สถานะการซ่อม", key: "repair_status_id" },
            ];

            const workBook = XLSX.utils.book_new();
            const workSheet = XLSX.utils.json_to_sheet(data, { header: headersColumn.map((h) => h.key) });
            XLSX.utils.sheet_add_aoa(workSheet, [headersColumn.map((h) => h.header)], { origin: "A1" });

            const margin = 5;
            const firstColumnWidth = 30;
            workSheet["!cols"] = headersColumn.map((header, index) => ({
                wch: index === 0 ? firstColumnWidth : header.header.length + margin,
            }));

            const range = XLSX.utils.decode_range(workSheet["!ref"]);
            const bgColor = "#c0d4ac"; 

            for (let R = range.s.r; R <= range.e.r; ++R) {
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const cellAddress = XLSX.utils.encode_cell({ c: C, r: R });
                    let cell = workSheet[cellAddress];
                    if (!cell) {
                        cell = { v: "" }; // Add an empty cell if it doesn't exist
                        workSheet[cellAddress] = cell;
                    }

                    if (R === 0) {
                        cell.s = {
                            font: { bold: true },
                            fill: { fgColor: { rgb: bgColor.replace("#", "") } },
                            border: {
                                bottom: { style: "thin" },
                                right: { style: "thin" },
                                left: { style: "thin" },
                                top: { style: "thin" },
                            },
                            alignment: { horizontal: "center", vertical: "center" },
                        };
                    } else {
                        cell.s = {
                            font: { bold: false },
                            border: {
                                bottom: { style: "thin" },
                                right: { style: "thin" },
                                left: { style: "thin" },
                                top: { style: "thin" },
                            },
                            alignment: { horizontal: "center", vertical: "center" },
                        };
                    }
                }
            }

            XLSX.utils.book_append_sheet(workBook, workSheet, "Report");
            XLSX.writeFile(workBook, "Repair.xlsx");
            this.$message.success({ content: "สร้างไฟล์สำเร็จ", key: "loading" });
        },
        showPreview(e, fileUrl) {
            e.stopPropagation();
            this.previewImage = fileUrl;
            this.previewVisible = true;
        },
        async getBase64ImageFromURL(url) {
            const res = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
            });
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        async handlePreview(file) {
            const isImage =
                file.type?.startsWith("image") ||
                file.url?.match(/\.(png|jpe?g|gif|webp)$/i);
            
            if (isImage) {
                if (!file.url && !file.preview) {
                file.preview = await this.getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
                this.isFilePreview = false;
                return;
            }
            const response = await fetch(file.url, { mode: "cors" });
            const blob = await response.blob();

            let extension = "";
            if (file.url) {
                const match = file.url.match(/\.(pdf|docx?|xlsx?|png|jpe?g|gif|webp|document)$/i);
                extension = match ? match[1] == "document" ? ".docx" : `.${match[1]}` : "";
            }
            const downloadName = (file.name || "RepairFile") + extension;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = downloadName;
            link.click();
            URL.revokeObjectURL(link.href);
        },
        async getBase64Image(e, file) {
            e.stopPropagation();
            e.preventDefault();

            if (typeof file === 'string') {
                const result = await this.getBase64ImageFromURL(file);
                let a = document.createElement('a');
                a.href = result;
                a.download = 'image.png';
                a.click();
            } else if (file.url) {
                const result = await this.getBase64ImageFromURL(file.url);

                // download
                let a = document.createElement('a');
                a.href = result;
                a.download = 'image.png';
                a.click();
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => {
                    const base64String = reader.result;
                    let a = document.createElement('a');
                    a.href = base64String;
                    a.download = 'image.png';
                    a.click();
                };
            }
        },
        repairebyCarCompany() {
            this.repaireCarCompany = this.car_list.filter(item => item.car_company_id === this.car_repair.car_company_id)
        },
        async get_business_type(){
            try {
                const data = await UserService.get_user_profile();
                let result = await CompanyService.getBusinessId(data.company_id);
                this.businessTypeId = result.data;
                return this.businessTypeId;
            } catch (error) {
                console.error('Error fetching business type:', error);
            }
        },
        hexToRgba(hex, alpha) {
            hex = hex.replace('#', '');
            const bigint = parseInt(hex, 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        },
        repairStatusStyle(statusId) {
            let color = '';
            switch (statusId) {
                case 1:
                    color = '#FFA64D';
                    break;
                case 2:
                    color = '#FD00CF';
                    break;
                case 3:
                    color = '#1D39C4';
                    break;
                case 4:
                    color = '#389E62';
                    break;
                default:
                    color = '#FFA64D';
                    break;
            }
            const opacityBackground = this.hexToRgba(color, 0.3);
            return `border: 1px solid ${color}; 
                    background-color: ${opacityBackground}; 
                    color: ${color};
                    display: inline-block;
                    padding: 4px 8px;`;
        },
        getRepairStoryTypeNameEdit(id) {
            const type = this.repairStoryTypesList.find(item => item.id === id);
            return type ? type.name : '';
        },
        getRepairStoryTypeName(id) {
            const target = this.repairStoryTypesList.find(({ id: repair_story_type_id }) => repair_story_type_id == id);
            return target ? `${target.name}` : "";
        },
        async init_edit_repair() {
            var repair = await CarCompanyService.get_car_repair_detail(this.$route.params.type)
            const { photo_1, photo_2, photo_3, photo_4, photo_5 } = repair
            const photos = [photo_1, photo_2, photo_3, photo_4, photo_5].filter(e => e != null).map((photo, i) => {
                return {
                    uid: i,
                    name: "RepairFile_"+(i+1),
                    status: 'done',
                    url: photo
                }
            })
            this.car_repair = repair
            this.car_repair.photos = photos
            this.car_repair.created_at = dayjs(repair.created_at)
            this.car_repair.time_start = dayjs(repair.time_start)
            this.car_repair.time_end = dayjs(repair.time_end)
            this.select_car(this.car_repair.car_id)
        },
        render_date(datetime) {
            return dayjs(datetime).format('DD/MM/YYYY HH:mm')
        },
        remove_repair_story_photo(e) {
            const { url } = e
            this.fileList = this.fileList.filter(({ status }) => status != 'removed')
            this.repair_story_photos.splice(this.repair_story_photos.indexOf(url), 1)
        },
        submit_repair_story() {
            if (this.repair_story.repair_story_type_id == 0 && !this.repair_story.repair_story_type_other) {
                Swal.fire({
                    title: 'ข้อมูลไม่ครบถ้วน',
                    text: 'กรุณาระบุประเภทรายการซ่อมอื่นๆ',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
                return;
            }
            if(!this.repair_story.story || !this.repair_story.repair_story_type_id || !this.repair_story.location || !this.repair_story.repair_expense) {
                Swal.fire({
                    title: 'ข้อมูลไม่ครบถ้วน',
                    text: 'กรุณาระบุประเภทรายการแจ้งซ่อม',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
                return;
            }
            let j = 0;
            var photo_url_list = this.fileList.filter(f=> f.url)
            for (var i = 0; i < photo_url_list.length; i++) {
                const target = photo_url_list[i]
                j = i+1;
                this.repair_story['photo_' + (j)] = target.url
            }

            let k = 0;
            for (var i = 0; i < this.repair_story_photos.length; i++) {
                const target = this.repair_story_photos[i]
                k = k+1;
                this.repair_story['photo_' + (k)] = target
            }

            this.repair_story.repair_story_type_id = this.repair_story.repair_story_type_id || null;
            this.repair_story.repair_story_type_other = this.repair_story.repair_story_type_other || '';
            this.repair_story.repair_expense = this.repair_story.repair_expense || null;
            this.repair_story.location = this.repair_story.location || null;
            
            if(this.is_update_modal){
                this.car_repair.repair_story[this.update_story_index] = this.repair_story
            }else{
                this.car_repair.repair_story.push(this.repair_story)
            }
            this.repair_story = {}
            this.update_story_index = null
            this.show_drawer = false
        },
        open_drawer() {
            this.repair_story = {}
            this.fileList = []
            this.show_drawer = true
            this.repair_story_photos = []
        },
        async handleBeforeUpload(file) {
            // Convert file to Base64
            const base64 = await this.getBase64(file)
            this.repair_story_photos.push(base64)

            this.fileList.push({
                uid: file.uid,
                name: file.name,
                status: 'done', 
                url: base64,
            })

            return false
        },
        async handleBeforeUploadCarRepair(file) {
            // Convert file to Base64
            const base64 = await this.getBase64(file)
            this.car_repair_photos.push(base64)

            this.car_repair.photos.push({
                uid: file.uid,
                name: file.name,
                status: 'done', 
                url: base64,
            })

            return false
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = reject
            })
        },
        async upload_files(e) {
            this.getBase64(e, 'car_repair_photos')
            return `https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6`
        },
        async upload_story(e) {
            this.getBase64(e, 'repair_story_photos')
            return `https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6`
        },
        async select_car(car_id) {
            await SystemService.get_id('Car', car_id)
                .then(res => {
                    this.selected_car = res
                    this.selected_car.car_type_name = this.selected_car.car_type?.name
                    this.selected_car.car_type_id = this.selected_car.car_type?.id
                    const { driver } = this.selected_car
                    this.selected_car.driver_name = driver?.firstname
                    this.selected_car.driver_tel = driver?.phone_no
                })
        },
        async submit_create_car_repair() {
            if (!this.car_repair.car_company_id || !this.car_repair.car_id || !this.car_repair.car_repair_type_id || !this.car_repair.created_at) {
                Swal.fire({
                    title: 'ข้อมูลไม่ครบถ้วน',
                    text: 'กรุณากรอกข้อมูลให้ครบถ้วน',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
                return;
            }
            for (var i = 0; i < this.car_repair_photos.length; i++) {
                const target = this.car_repair_photos[i]
                this.car_repair['photo_' + (i + 1)] = target
            }
            this.car_repair.car_type_id =  this.selected_car.car_type_id
            this.car_repair.car_repair_type_id = this.car_repair.car_repair_type_id;
            Swal.fire({
                title: 'กรุณารอสักครู่',
                text: 'กำลังบันทึกข้อมูล',
                allowOutsideClick: false,
                didOpen: async () => {
                    Swal.showLoading()
                    await CarCompanyService.create_car_repair(this.car_repair)
                        .then(res => {
                            if (res) {
                                Swal.close()
                                this.car_repair = {
                                    car_repair_photos: []
                                }
                                this.car_repair_photos = []
                                this.clear_selected_car()
                                this.init_repair()
                                this.$router.go(-1)
                            }
                        })
                },
                willClose: () => {
                    Swal.fire({
                        title: 'สร้างรายการสำเร็จ',
                        icon: 'success',
                        timer: 1000,
                        timerProgressBar: false,
                        showConfirmButton: false,
                    })
                }
            })
        },
        async submit_update_car_repair() {
            const { id } = this.car_repair
            this.car_repair.photo_1 = null
            this.car_repair.photo_2 = null
            this.car_repair.photo_3 = null
            this.car_repair.photo_4 = null
            this.car_repair.photo_5 = null

            let j = 0;
            var photo_url_list = this.car_repair.photos.filter(f=> f.url)

            for (var i = 0; i < photo_url_list.length; i++) {
                const target = photo_url_list[i]
                j = i+1;
                this.car_repair['photo_' + (j)] = target.url
            }
            for (var i = 0; i < this.car_repair_photos.length; i++) {
                const target = this.car_repair_photos[i]
                j = j+1;
                this.car_repair['photo_' + (j)] = target
            }

            this.car_repair.car_repair_type_id = this.car_repair.car_repair_type_id || null;
            Swal.fire({
                title: 'กรุณารอสักครู่',
                text: 'กำลังบันทึกข้อมูล',
                allowOutsideClick: false,
                didOpen: async () => {
                    Swal.showLoading()
                    await CarCompanyService.edit_car_repair(id, this.car_repair)
                        .then(res => {
                            if (res) {
                                Swal.close()
                                this.init_repair()
                            }
                        })
                },
                willClose: () => {
                    Swal.fire({
                        title: 'บันทึกข้อมูลสำเร็จ',
                        icon: 'success',
                        timer: 1000,
                        timerProgressBar: false,
                        showConfirmButton: false,
                    })
                }
            })
            this.$router.go(-1)
            this.init_repair()
        },
        remove_car_repair(id) {
            Swal.fire({
                title: 'คุณต้องการลบรายการนี้ใช่หรือไม่?',
                text: "คุณจะไม่สามารถกู้คืนรายการนี้ได้!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ใช่, ลบรายการนี้!',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                if (result.isConfirmed) {
                    CarCompanyService.remove_car_repair(id).then(res => {
                        this.init_repair()
                        Swal.fire(
                            'ลบรายการสำเร็จ!',
                            'รายการของคุณถูกลบแล้ว',
                            'success'
                        )
                    })
                }
            })
        },
        edit_repair_status(id, repair) {
            const { car_repair_status_id } = repair
            this.show_modal = true
            this.selected_repair_id = id
            this.selected_repair_status = car_repair_status_id
        },
        create_car_repair_story(){
            this.is_update_modal = false
            this.open_drawer()
        },
        edit_car_repair_story(index, data){
            this.is_update_modal = true
            this.car_repair_photos = []
            this.open_drawer()
            const { id, story, detail, repair_story_type_id, repair_story_type_other, repair_expense, photo_1, photo_2, photo_3, photo_4, photo_5, location } = data
            const photos = [photo_1, photo_2, photo_3, photo_4, photo_5].filter(e => e != null).map((photo, i) => {
               return photo.uid ? photo : {
                        uid: i,
                        name: photo+1,
                        status: 'done',
                        url: photo
                }
            })

            this.fileList = photos
            this.repair_story.id = id
            this.repair_story.story = story
            this.repair_story.detail = detail
            this.repair_story.repair_story_type_id = repair_story_type_id
            this.repair_story.repair_story_type_other = repair_story_type_other
            this.repair_story.repair_expense = repair_expense
            this.repair_story.location = location
            this.is_update_modal = true
            this.update_story_index = index
        },
        remove_car_repair_story(index, data){
            if(data.id){
                Swal.fire({
                title: 'คุณต้องการลบรายการนี้ใช่หรือไม่?',
                text: "คุณจะไม่สามารถกู้คืนรายการนี้ได้!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ใช่, ลบรายการนี้!',
                cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                    if (result.isConfirmed) {
                        SystemService.delete_all('RepairStory',data.id).then(res => {
                            this.car_repair.repair_story.splice(index, 1)
                            this.init_repair()
                            Swal.fire(
                                'ลบรายการสำเร็จ!',
                                'รายการของคุณถูกลบแล้ว',
                                'success'
                            )
                        })
                    }
                })
            }else{
                this.car_repair.repair_story.splice(index, 1)
            }
        },
        async save_status() {
            // await CarCompanyService.edit_repair_status(this.selected_repair_id, { car_repair_status_id: this.selected_repair_status })
            const res = await SystemService.update_all('CarRepair', { data: { car_repair_status_id: this.selected_repair_status } }, this.selected_repair_id)
            this.selected_repair_status = null
            this.show_modal = false
            this.init_repair()
            Swal.fire(
                'แก้ไขสถานะสำเร็จ!',
                'แก้ไขสถานะรายการแจ้งซ่อมสำเร็จแล้ว',
                'success'
            )
        },
        clear_search() {
            this.selected_company = null
            this.selected_status = null
            this.search_car = null
            this.selected_type_id = null
            this.car_filter_list = [];
        },
        clear_selected_car() {
            this.selected_car = {}
            this.car_repair = {
                photos: [],
                repair_story: []
            }
            this.car_repair_photos = []
        },
        filtered_list(array) {
            return array.filter(item => {
                if (this.selected_company && this.selected_status) {
                    return item.car_company_id == this.selected_company && item.car_repair_status_id == this.selected_status
                } else if (this.selected_company) {
                    return item.car_company_id == this.selected_company
                } else if (this.selected_status) {
                    return item.car_repair_status_id == this.selected_status
                } else {
                    return true
                }
            })
            .filter(({ car_repair_type_id }) => {
                if (this.selected_type_id) {
                    return car_repair_type_id == this.selected_type_id
                } else {
                    return true
                }
            })
            .filter(({ car }) => {
                if (this.search_car) {
                    return car.includes(this.search_car)
                } else {
                    return true
                }
            }).sort((a,b) => b.id - a.id)
        },
        async init_businessType() {
            this.businessType = await CompanyService.getBusinessId(this.car_company_list[0].company_id)
            if (this.businessType.data === 2){
                this.business = true
            }
        },
        async init_repair() {
            this.car_company_list = await SystemService.get_all('CarCompany')
            this.init_businessType()
            this.repairing_list = await CarCompanyService.get_car_repair()
            this.plate_no_list = [
                ...new Map(
                    this.repairing_list.map((item, index) => [item.car, { id: index + 1, name: item.car }])
                ).values(),
            ];
            this.repair_status_list = await SystemService.get_all('CarRepairStatus')
            this.car_list = await SystemService.get_all('Car')
            this.car_repair_type_list = await SystemService.get_all('CarRepairType')
            this.repairStoryTypesList = await SystemService.get_core('getRepairStoryTypes')
            this.car_listByCarCompany = this.car_list.filter(item => item.car_company_id == 0)

        }
    },
    mounted() {
        this.init_repair()
        this.get_business_type();
    }
}
</script>

<style scoped>
.ant-form-item {
    margin: 0
}
.ant-table-thead .center-header {
  text-align: center; /* จัดตำแหน่งหัวคอลัมน์ให้อยู่ตรงกลาง */
}
.image-container {
    position: relative;
    display: inline-block;
}
.uploaded-image-table {
    display: block;
    width: 12rem;
    height: auto;
}
</style>